<template>
  <v-row>
    <v-col
      v-if="isCaseTypeRelatedToCompanyBranch"
      cols="12"
      lg="4"
    >
      <naj-input
        :type-id="formFieldType.radioButton"
        :value.sync="isTherePartyPlaceCondition"
        :label="local.lawsuitDetails.isOneOfPartiesIsCompany"
        :items="yesNoOption"
        :disabled="disabled"
        item-value="id"
        item-text="name"
        validates="required"
        @change="isTherePartyPlaceConditionChangedEvent"
      ></naj-input>
    </v-col>
    <template v-if="isTherePartyPlaceCondition == yesOrNoEnum.yes">
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.companyBranchCity"
          :value.sync="cityId"
          :items="citiesByCourtType[courtTypeId]"
          :disabled="!(citiesByCourtType[courtTypeId] || []).length || disabled"
          item-value="id"
          item-text="name"
          :validates="'required'"
          @change="companyBranchCityChanged"
        ></naj-input>
      </v-col>

      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.court"
          :value="courtId"
          :items="cityCourtByType[cityId]"
          item-value="id"
          item-text="name"
          :validates="'required'"
          :disabled="disabled"
          @change="updateCourtId"
        ></naj-input>
        <span class="user-attention">
          {{ local.lawsuitDetails.companyBranchAttention }}
        </span>
      </v-col>
    </template>
    <template v-if="isTherePartyPlaceCondition == yesOrNoEnum.no">
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.court"
          :value="courtId"
          :items="closestCourts"
          :disabled="disabled"
          item-value="id"
          item-text="name"
          :validates="'required'"
          @change="updateCourtId"
        ></naj-input>
        <span
          v-if="caseData.isRelatedToCorona"
          class="user-attention"
        >
          {{ local.lawsuitDetails.coronaAttention }}
        </span>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { yesOrNoEnum, caseClassificationEnum } from '@/helpers/enum';
import {
  isPersonalLawsuit,
  isGeneralLawsuit,
} from '../../../helpers/utils';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('LawsuitModule');
const { mapActions: mapLUTActions, mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');

export default {
  inject: ['$validator'],
  props: ['courtId', 'partiesInfo', 'disabled', 'handleGetCourtsInvoker', 'disableLocationSpecializationRule'],
  data() {
    return {
      yesOrNoEnum,
      isPersonalLawsuit,
      isGeneralLawsuit,
      closestCourts: [],
      cityId: null,
      isTherePartyPlaceCondition: null,
    };
  },
  computed: {
    ...mapState({ caseData: state => state.lawsuitRequest.case }),
    ...mapLUTState(['yesNoOption', 'citiesByCourtType', 'cityCourtByType']),
    ...mapGetters(['selectedCaseType']),
    courtTypeId() {
      return this.isPersonalLawsuit(this.caseData) ? caseClassificationEnum.family : this.isGeneralLawsuit(this.caseData) ? caseClassificationEnum.general : 0;
    },
    isCaseTypeRelatedToCompanyBranch() {
      return this.selectedCaseType && this.selectedCaseType.isCaseTypeRelatedToCompanyBranch;
    },
  },
  watch: {
    handleGetCourtsInvoker(invoker) {
      if (invoker)
        this.handleGetCourts(invoker);
    },
    'cityId': function (value) {
      this.$set(this.caseData, 'cityId', value);
    },
    'isTherePartyPlaceCondition': function (value) {
      this.$set(this.caseData, 'isTherePartyPlaceCondition', value);
      if (!this.isCaseTypeRelatedToCompanyBranch)
        this.isTherePartyPlaceCondition = yesOrNoEnum.no;
    },
  },
  mounted() {
    this.cityId = this.caseData.cityId || null;
    this.isTherePartyPlaceCondition = this.caseData.isTherePartyPlaceCondition !== undefined ? this.caseData.isTherePartyPlaceCondition : null;
    if (!this.isCaseTypeRelatedToCompanyBranch)
      this.isTherePartyPlaceCondition = yesOrNoEnum.no;
    this.handleGetCourts('mounted');
  },

  methods: {
    ...mapActions(['getPartiesClosestCourts']),
    ...mapLUTActions(['getCitiesByCourtType', 'getPersonalCityCourtByType']),
    handleGetPartiesClosestCourts(invoker) {
      const caseTypeId = this.caseData.caseTypeId || null;
      const caseCategoryId = this.caseData.caseCategoryId || null;
      const caseClassificationId = this.caseData.caseClassificationIdNew || null;
      const disableLocationSpecializationRule = this.disableLocationSpecializationRule || null;
      const accidentCityId = this.cityId || null;
      const isRelatedToCorona = this.caseData.isRelatedToCorona || null;
      if (caseTypeId && caseCategoryId && caseClassificationId && (this.partiesInfo || []).length) {
        const data = {
          invoker,
          caseTypeId,
          caseCategoryId,
          caseClassificationId,
          accidentCityId,
          disableLocationSpecializationRule,
          isRelatedToCorona,
          partiesInfo: this.partiesInfo,
          form: (this.caseData.forms || [])[0],
        };
        this.getPartiesClosestCourts(data)
          .then(({ data }) => {
            this.closestCourts = data.data;
            this.$emit('courtsRetrieved', this.closestCourts);
          });
      }
    },
    isTherePartyPlaceConditionChangedEvent() {
      this.$set(this, 'cityId', null);
      this.updateCourtId(null);
      this.handleGetCourts('isTherePartyPlaceConditionChangedEvent');
    },
    companyBranchCityChanged(value) {
      if (value) {
        this.getPersonalCityCourtByType(this.cityId)
          .then((cityCourt) => {
            this.updateCourtId((cityCourt || [{ id: null }])[0].id);
          });
      }
    },
    handleGetCourts(invoker) {
      if (((this.isPersonalLawsuit(this.caseData) && this.isTherePartyPlaceCondition == yesOrNoEnum.yes))) {
        this.getCitiesByCourtType(this.courtTypeId);
        if (this.cityId)
          this.getPersonalCityCourtByType(this.cityId);
      }
      else
        this.handleGetPartiesClosestCourts(invoker);
    },
    updateCourtId(courtId) {
      this.$emit('update:courtId', courtId);
      this.$emit('change', courtId);
    },
  },
};
</script>
<style lang="scss" scoped>
.user-attention {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
</style>
